

























import { Vue, Component, Prop } from 'vue-property-decorator';
import ToggleSwitch from '@/components/UiComponents/ToggleSwitch.vue';
import store from '@/store';
import { Workflow } from '@/store/models/workflow/workflow';
import * as $ from 'jquery';


@Component({
    components: { ToggleSwitch}
})
export default class SingleEnterpriseSearch extends Vue {

    showForms = false;
    @Prop() workflows?: Workflow[];

    formFilterSelection(checked: boolean, formId: string) {
        store.state.eventHub.$emit("form-selection",{ isSelected: checked, formId: formId });

    }
    
    ischecked=false;
    setToAll(checked: boolean,allEnterpriseForms: Array<any>){
        allEnterpriseForms.forEach(element => {
            this.formFilterSelection(checked, element.id);
        });
        if(this.ischecked==true){
            this.check(true);
            this.ischecked=false;
        }else if (this.ischecked== false){
            this.check(false);
            this.ischecked=true;
        }
    }

    check(checked: boolean) {
        // const cbs = $('#select_all .checked') as HTMLInputElement;
        // const element= document.querySelectorAll("[name='selectall']") ;
        // var x = document.getElementById("myDIV")?.querySelectorAll(".example");
        const allCheckBoxes = document.getElementById("select_all")?.querySelectorAll("input[name='checkbox']") as NodeListOf<HTMLInputElement>;
        allCheckBoxes.forEach(checkBox => {
            checkBox.checked = checked;
        });
    }
}
